// extracted by mini-css-extract-plugin
export default {"scoresContainer":"ScorePage_scoresContainer__WVz3L","scoreContainer":"ScorePage_scoreContainer__I5OtY","scoreContent":"ScorePage_scoreContent__IZ5hj"};